import StringHelper from "@/CommonVueCore/src/helpers/stringHelpers";
import EnumHelper from "@/CommonVueCore/src/helpers/enumhelpers";

// import loadAppSettings from "@/configs/appsettings.js";
import { SweetAlertService } from "@/CommonVueCore/src/services/sweetAlert2Service/sweetAlert2Service";
import { SweetToastrService } from "@/CommonVueCore/src/services/sweetAlert2Service/sweetToastr2Service";
import { ComplexService } from "@/CommonVueCore/src/services/complexService/complexService";
import { FormValidationService } from "@/CommonVueCore/src/services/formService/formValidationService";
import DevExtremeService from "@/CommonVueCore/src/services/devExtremeService/devExtremeService";
import { DevextremeCrudService } from "../services/devExtremeServices/devExtremeCrudService";
import { FileManagerService } from "../services/fileService/fileManagerService";
import { ErrorMessageService } from "../services/errorMessageService/errorMessageService";
import { AuthService } from "@/services/authService/authService.js";
import { PurchaseRequestService } from "@/services/purchaseRequestService/purchaseRequestService.js";
import { ValidationPurchaseRequestService } from "@/services/purchaseRequestService/validationPurchaseRequestService.js";
import { PurchaseOrderService } from "@/services/purchaseOrderService/purchaseOrderService.js";
import { ProcurementService } from "@/services/procurementService/procurementService.js";
import { ProductService } from "../services/productService/productService";
import { ProductCatalogService } from "../services/productService/productCatalogService";
import { CostCentreService } from "../services/costCentreService/costCentreService";
import { BudgetTrackingService } from "../services/budgetTrackingService/budgetTrackingService";
import { FinanceService } from "../services/financeService/financeService";
import { ReportService } from "../services/reportService/reportService";
import { PermissionService } from "@/services/permissionService/permissionService.js";
import { SupplierService } from "@/services/supplierService/supplierService.js";
import { PRApprovalMatrixService } from "../services/prApprovalMatrixService/prApprovalMatrixService";
import { POApprovalMatrixService } from "../services/poApprovalMatrixService/poApprovalMatrixService";
import { TranslateApiService } from "../services/translateApiService/translateApiService";
import { NumberFormatService } from "@/services/formatService/numberFormatService";
import { AnimateService } from "@/CommonVueCore/src/services/animateService/animateService.js";

import {
  createApiClient,
  CProXServiceClient,
} from "../serviceClients/CProXServiceClient";
// import { OriginAuthServiceClient } from "@/serviceClients/OriginAuthServiceClient";
// import { ProductManagementServiceClient } from "../serviceClients/ProductManagementServiceClient";
import { AuthenticationServiceClient } from "../serviceClients/AuthenticationServiceClient";
import { PurchaseRequestServiceClient } from "../serviceClients/PurchaseRequestServiceClient";
import { PurchaseOrderServiceClient } from "../serviceClients/PurchaseOrderServiceClient";
// import { ProcurementServiceClient } from "../serviceClients/ProcurementServiceClient";
import { PRApprovalMatrixServiceClient } from "../serviceClients/PRApprovalMatrixServiceClient";
import { TranslateApiServiceClient } from "../serviceClients/TranslateApiServiceClient";
import { CurrencyService } from "@/services/currencyService/currencyService";
import { useAuthAppStore } from "@/store/stores/authStore";
// import { POApprovalMatrixServiceClient } from "../serviceClients/POApprovalMatrixServiceClient";
// import { CostCentreServiceClient } from "../serviceClients/CostCentreServiceClient";
// import { FinanceServiceClient } from "../serviceClients/FinanceServiceClient";
// import { SupplierServiceClient } from "../serviceClients/SupplierServiceClient";
// import { ReportServiceClient } from "../serviceClients/ReportServiceClient";
// import { BlobServiceClient } from "../serviceClients/BlobServiceClient";

export function registerServiceClients(app) {
  var connectedProjectUrlObj =
    window.appsettings.ProjectConfig.ConnectedProject;
  // app.provide(
  //   "productManagementServiceClient",
  //   new ProductManagementServiceClient({
  //     baseUri: connectedProjectUrlObj.ProductManagementServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "authenticationServiceClient",
  //   new AuthenticationServiceClient({
  //     baseUri: connectedProjectUrlObj.AuthenticationServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "purchaseRequestServiceClient",
  //   new PurchaseRequestServiceClient({
  //     baseUri: connectedProjectUrlObj.PurchaseRequestServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "purchaseOrderServiceClient",
  //   new PurchaseOrderServiceClient({
  //     baseUri: connectedProjectUrlObj.PurchaseOrderServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "procurementServiceClient",
  //   new ProcurementServiceClient({
  //     baseUri: connectedProjectUrlObj.PRApprovalMatrixServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "prApprovalMatrixServiceClient",
  //   new PRApprovalMatrixServiceClient({
  //     baseUri: connectedProjectUrlObj.PRApprovalMatrixServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "poApprovalMatrixServiceClient",
  //   new POApprovalMatrixServiceClient({
  //     baseUri: connectedProjectUrlObj.POApprovalMatrixServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "costCentreServiceClient",
  //   new CostCentreServiceClient({
  //     baseUri: connectedProjectUrlObj.CostCentreServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "financeServiceClient",
  //   new FinanceServiceClient({
  //     baseUri: connectedProjectUrlObj.FinanceServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "supplierServiceClient",
  //   new SupplierServiceClient({
  //     baseUri: connectedProjectUrlObj.SupplierServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "reportServiceClient",
  //   new ReportServiceClient({
  //     baseUri: connectedProjectUrlObj.ReportServiceClientUrl,
  //   })
  // );
  // app.provide(
  //   "blobServiceClient",
  //   new BlobServiceClient({
  //     baseUri: connectedProjectUrlObj.BlobServiceClientUrl,
  //   })
  // );

  // app.provide(
  //   "cproxServiceClient",
  //   new CProXServiceClient({
  //     baseUri: window.appsettings.ProjectConfig.ReqifyApiServiceClientUrl,
  //   })
  // );

  // TranslateApi standalone microservice — diger CproX servisleri gateway
  // arkasinda; TranslateApi'yi de yarin gateway'e ekledigimizde TranslateApiUrl
  // config'i `${CProXApiServiceClientUrl}/translate`'e cekilecek.
  app.provide(
    "translateApiServiceClient",
    new TranslateApiServiceClient({
      baseUri: window.appsettings.ProjectConfig.ConnectedProject.TranslateApiUrl,
    })
  );

   app.provide("cproxServiceClient", {
    authentication: new AuthenticationServiceClient({
       baseUri: `${window.appsettings.ProjectConfig.ConnectedProject.CProXApiServiceClientUrl}/authentication`
    }),
    finance: createApiClient("finance", new AuthService().checkExpireBeforeRequest),
    product: createApiClient("product", new AuthService().checkExpireBeforeRequest),
    poApproval: createApiClient("po-approval", new AuthService().checkExpireBeforeRequest),
    prApproval: createApiClient("pr-approval", new AuthService().checkExpireBeforeRequest),
    supplier: createApiClient("supplier", new AuthService().checkExpireBeforeRequest),
    pOrder: createApiClient("purchase-order", new AuthService().checkExpireBeforeRequest),
    pRequest: createApiClient("purchase-request", new AuthService().checkExpireBeforeRequest),
    blobStorage: createApiClient("storage", new AuthService().checkExpireBeforeRequest),
    report: createApiClient("report", new AuthService().checkExpireBeforeRequest),
    costCenter: createApiClient("cost-center", new AuthService().checkExpireBeforeRequest),
    currency: createApiClient("currency", new AuthService().checkExpireBeforeRequest),
  });

  // app.provide("originTestAuthServiceClient", new OriginAuthServiceClient({ baseUri: "http://auth.origin.api.test.yph.inc/" }))
}

// export async function checkExpireBeforeRequest() {
//   const isAccessTokenExpired = useAuthAppStore().checkExpiredNow();
//   console.log("isAccessTokenExpired", isAccessTokenExpired);

//   let user = useAuthAppStore().getUserAuthState;

//   let authServiceClient = new CProXServiceClient({
//     baseUri:
//       window.appsettings.ProjectConfig.ConnectedProject
//         .CProXApiServiceClientUrl,
//   });

//   const refreshTokenExpiry = parseDate(user.refreshTokenExpired);
//   console.log("refreshTokenExpiry", refreshTokenExpiry);
  

//   const now = new Date();

//   const isRefreshTokenExpired = refreshTokenExpiry <= now;

//   if (isAccessTokenExpired) {
//     if (!isRefreshTokenExpired) {
//       // Refresh token geçerli → yeni access token iste
//       const response = await authServiceClient.get({
//         route: "/authentication/access-token",
//         params: { RefreshToken: user.refreshToken },
//       });
//       // Yeni access token’ı store’a kaydet
//       // authStore.setAccessToken(response.data.accessToken);
//       // authStore.setLogin(response.data.accessToken);
//       console.log("Access Token dolmus. burada yenilenmiş access token var -> ", response.data.accessToken);
      
//     } else {
//       // Refresh token da bitmiş → kullanıcıyı login modal ile yönlendir
//       // authStore.clearAuth();
//       // authStore.openLoginModal();
//     }
//   }
// }

// function parseDate(msDateString) {
  
//   if (!msDateString) return null;

//   // Eğer sayı gelirse (timestamp gibi)
//   if (!isNaN(msDateString)) {
//     if (msDateString.toString().length === 10) {
//       return new Date(parseInt(msDateString, 10) * 1000);
//     }
//     return new Date(parseInt(msDateString, 10));
//   }

//   // ISO format
//   if (typeof msDateString === "string" && msDateString.includes("T")) {
//     return new Date(msDateString);
//   }

//   // .NET formatı (/Date(1234567890)/ veya /Date(1234567890))
//   if (typeof msDateString === "string") {
//     const match = /\/Date\((\d+)\)\/?/.exec(msDateString);
//     if (match) {
//       return new Date(parseInt(match[1], 10));
//     }
//   }

//   return null;
// }

export function registerServices(app) {
  app.provide("stringHelpers", new StringHelper());
  app.provide("enumHelpers", new EnumHelper());

  app.provide("fileManagerService", new FileManagerService());
  app.provide("errorMessageService", new ErrorMessageService());

  app.provide("sweetAlertService", new SweetAlertService({}));
  app.provide("sweetToastrService", new SweetToastrService({}));
  app.provide("complexService", new ComplexService({}));
  app.provide("formValidationService", new FormValidationService());
  app.provide("devExtremeGridService", new DevExtremeService());
  app.provide("permissionService", new PermissionService());
  app.provide("supplierService", new SupplierService());
  app.provide("animateService", new AnimateService());

  app.provide("purchaseRequestService", new PurchaseRequestService());
  app.provide(
    "validationPurchaseRequestService",
    new ValidationPurchaseRequestService()
  );
  app.provide("authService", new AuthService());
  app.provide("purchaseOrderService", new PurchaseOrderService());
  app.provide("procurementService", new ProcurementService());
  app.provide("productService", new ProductService());
  app.provide("productCatalogService", new ProductCatalogService());
  app.provide("costCentreService", new CostCentreService());
  app.provide("budgetTrackingService", new BudgetTrackingService());
  app.provide("financeService", new FinanceService());
  app.provide("currencyService", new CurrencyService());

  app.provide("reportService", new ReportService());
  app.provide("prApprovalMatrixService", new PRApprovalMatrixService());
  app.provide("poApprovalMatrixService", new POApprovalMatrixService());
  app.provide("translateApiService", new TranslateApiService());

  app.provide("devextremeCrudService", new DevextremeCrudService());

  app.provide("numberFormatService", new NumberFormatService());
}
